import editIcon from "../../../../img/pencil-icon.svg";
import deleteIcon from "../../../../img/delete-icon-orange.svg";
import copyIcon from "../../../../img/copy-icon.svg";
import openIcon from "../../../../img/open-in-icon.svg";
import saveIcon from "../../../../img/save-icon.svg";
import closeIcon from "../../../../img/close-icon-button.svg";
import CustomSwitch from "../../../../components/CustomSwitch";
import { IconButton, MenuItem, Select } from "@mui/material";
import { copyToClipBoard, linkIsFileInS3, getFileNameFromEHLink, downloadFile } from "../../../../utils";
import { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import ConfirmationModal from './../../../../components/basicModalConfirmation';
import { useDeleteResourceMutation } from "../../../../services/resourcesApi";

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import Button from '@mui/material/Button';

import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import ResourceHeaderDropdown from "./components/ResourceHeaderDropdown";


function EditButton(props) {
    
    return (
        <IconButton onClick={props.onClick}>
            <img src={editIcon} alt="edit icon" height="24px" width="24px" />
        </IconButton>
    )
}

function DeleteButton(props) {

    return (
        <IconButton onClick={props.onClick}>
            <img src={deleteIcon} alt="delete icon" height="24px" width="24px" />
        </IconButton>
    )
}

function CopyButton({copy}) {
    return (
        <IconButton onClick={()=>copyToClipBoard(copy)}>
            <img src={copyIcon} alt="copy icon" height="24px" width="24px" />
        </IconButton>
    )
}

function RedirectButton({url}) {
    return (
        <IconButton>
            <a style={{fontSize:"0"}} href={url} target="_blank" rel="noreferrer" ><img src={openIcon} alt="copy icon" height="24px" width="24px" /></a>
        </IconButton>
    )
}

function SaveButton(props) {
    return (
        <IconButton onClick={props.onClick}>
            <img src={saveIcon} alt="edit icon" height="24px" width="24px" />
        </IconButton>
    )
}

function CancelButton(props) {
    return (
        <IconButton onClick={props.onClick}>
            <img src={closeIcon} alt="edit icon" height="24px" width="24px" />
        </IconButton>
    )
}

const ResourceCard = ({resource, onEditHandler, onDeleteHandler, resourcesHeaders}) => {

    const [deleteResource,{isError, data, isLoading, isFetching}]=useDeleteResourceMutation();

    const [userInputSelection, setUserInputSelection] = useState(linkIsFileInS3(resource.url || "") ? "file":  "link");
    //A: in a new resource the user can set a external link or upload a file
    //so we need to keep track of the user choice, link by default

    const [localResource, setLocalResource] = useState(resource);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    useEffect(() => {
      setLocalResource(resource);
    }, [resource]);

    const handleEdit = () => {
        setCanEdit(!canEdit)
    }

    const handleDelete = async() => {
      console.log("ejecutando handle delete")
      let wasSuccesful= onDeleteHandler(localResource.id);
      if(wasSuccesful){
        setLocalResource({...localResource, active: !localResource.active})
      }
    }

    const onSave = async()=>{
      setCanEdit(!canEdit);
      console.log("form edit resource raw: " + JSON.stringify(localResource));
      const formData = new FormData();
      formData.append("title", localResource.title);
      formData.append("description", localResource.description || "");
      formData.append("id", localResource.id);
      formData.append("active", localResource.active);
      if(localResource.resourceHeaderId){
        formData.append("resourceHeaderId", localResource.resourceHeaderId);
      }
      if (localResource.url) {
        formData.append("url", localResource.url);
      } else {
        formData.append("file", localResource.file);
      }
      try {
        let res= await onEditHandler(formData);
        console.log("res edit: " + JSON.stringify(res));
      } catch (error) {
        setLocalResource(resource);
        throw error; //rethrow error to be catched by singalR
      }
    }

    const handleShowOrHideResource = async() => {
      const formData = new FormData();
      formData.append("id", localResource.id);
      formData.append("active", !localResource.active);
      formData.append("description", localResource.description);
      formData.append("url", localResource.url);

      let wasSuccesful= await onEditHandler(formData);
      setOpenConfirmationModal(false)
      if(wasSuccesful){
        setLocalResource({...localResource, active: !localResource.active})
        setCanEdit(false)
      }
    }

    function CustomFileIcon({fileLink}){
      let fileName= getFileNameFromEHLink(fileLink);

      return(
        <div style={{
          display: "flex",
          alignItems: "center"
        }}>
          <InsertDriveFileOutlinedIcon color="primary" sx={{margin: "0 0.5em 0 0"}}/>
          {fileName}
        </div>
      )
    }

    function CustomLinkIcon({fileLink}){
      return(
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start"

        }}>
          <LinkOutlinedIcon color="primary" sx={{margin: "0 0.5em 0 0"}}/>
          {fileLink}
        </div>
      )
    }

    const MAX_FILE_SIZE_MB = 200; // max file size in MB
    const handleFileChange = (e) => {
      if (e.target.files) {
        const fileSizeInBytes = e.target.files[0].size;
        const fileSizeInMB = fileSizeInBytes / (1024 * 1024);

        if (fileSizeInMB > MAX_FILE_SIZE_MB) {
          e.target.value = null;
          alert(`The selected file is too big. The maximum allowed size is ${MAX_FILE_SIZE_MB} MB`);
        } else {
          setLocalResource(prev => ({ ...prev, url: "", file: e.target.files[0] }))
        }
      }
    };

    function getFileName(){
      if(localResource.url && localResource.url != "" && !localResource.file && linkIsFileInS3(localResource.url)){
        return getFileNameFromEHLink(localResource.url);
      }
      else if(localResource.file){
        return localResource.file.name;
      }
      else{
        return "";
      }
    }

    function onChangeInputHandler(e) {
      // setFormErrors({ ...formErrors, [e.target.name]: "" });
      setLocalResource({ ...localResource, [e.target.name]: e.target.value });
      if (e.target.name == "url") {
        setLocalResource(prev => ({ ...prev, file: null }))
      }
      //A: if the user is changing the url input, we need to clear the file input
    }

    function LinkOrFileSelection() {
      return (
        <FormControl style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', whiteSpace: 'nowrap' }} >
          <FormLabel
            id="demo-controlled-radio-buttons-group"
            style={{ fontWeight: '600', color: 'var(--darkbrown)', margin: '0 2em 0 0' }}
          >
            Resource Type
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={userInputSelection}
            onChange={e=> setUserInputSelection(e.target.value)}
            row
            style={{ flexWrap: 'nowrap', margin: '0 2em 0 0' }}
          >
            <FormControlLabel value="link" control={<Radio />} label="Link" />
            <FormControlLabel value="file" control={<Radio />} label="File" />
          </RadioGroup>
        </FormControl>
      )
    }

    function DownloadButton({url}){
      return(
        // <a onClick={()=> downloadFile(url)} className="resource-card-title" >
        //   {getFileNameFromEHLink(url)}
        // </a>

        <IconButton>
        <a style={{fontSize:"0"}}  onClick={()=> downloadFile(url)} ><img src={openIcon} alt="copy icon" height="24px" width="24px" /></a>
        </IconButton>
      )
    }

    return ( 
        <div >
            {
            openDeleteModal && 
                <ConfirmationModal 
                    title={"Are you sure you want to delete this Resource?"} 
                    onClick={handleDelete} 
                    handleClose={()=>{
                      setOpenDeleteModal(false)
                      setCanEdit(false)
                    }}
                    open={openDeleteModal}
                    cancelLabel="No"
                    confirmLabel="Yes"
                    />
            }
            {
                openConfirmationModal?
                    <ConfirmationModal
                        open={openConfirmationModal}
                        title={`Are you sure you want to ${!localResource.active?"show":"hide"} this Resource?`}
                        onClick={handleShowOrHideResource}
                        handleClose={()=>{
                            setOpenConfirmationModal(false)
                            setCanEdit(false)
                        }}
                        />
                    : null
            }
            <div className="resource-head">
                {
                    canEdit?
                    <>
                        <label>Title: </label>
                        <TextField 
                            multiline={true}
                            maxRows={1}
                            variant="outlined"
                            sx={{ width: "100%", margin:"0 0 1em 0" }}
                            value={localResource.title}
                            onChange={(e)=>setLocalResource({...localResource, title: e.target.value})}
                        />
                    </>
                    :
                        <h4>{(localResource.title || "No Title")}</h4>
                }

                <div className="icon-buttons">
                    {canEdit? <> <SaveButton onClick={onSave} /> <CancelButton onClick={handleEdit} /> </> :<EditButton onClick={handleEdit}/>}
                    <DeleteButton onClick={()=>setOpenDeleteModal(true)}/>
                    <CustomSwitch onChange={()=>setOpenConfirmationModal(true)} checked={localResource.active} />
                </div>
            </div>
            
            <div className="resource-description">
                {
                
                canEdit?
                <>
                    <label>Description: </label>
                    <TextField
                        multiline={true}
                        maxRows={4}
                        name="Description"
                        variant="outlined"
                        id="resource-description-input"
                        sx={{ width: "100%" }}
                        value={localResource.description}
                        onChange={(e)=>setLocalResource({...localResource, description: e.target.value})}
                    />
                
                </>
                :
                    <p>{localResource.description}</p>
                
                }
            </div>
            <div className="resource-link">
                {!canEdit && !linkIsFileInS3(localResource.url) && <CustomLinkIcon fileLink={localResource.url}/> }
                {!canEdit && linkIsFileInS3(localResource.url) && <CustomFileIcon fileLink={localResource.url}/> }

                { 
                  canEdit && 
                  ( 
                    <>
                      <LinkOrFileSelection />
                      {userInputSelection === "link" ? 
                        <TextField
                          fullWidth={true}
                          multiline={true}
                          style={{ width: "50%"}}
                          // error={formErrors.url != ""}
                          // helperText={formErrors.url}
                          variant="outlined"
                          value={localResource.url}
                          name="url"
                          onChange={onChangeInputHandler}
                        />
                          
                      : 
                      <>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                        }}>

                          {/* edit resource form, upload file */}

                          <Button  sx={{margin: "0 0.5em 0 0"}} variant="outlined" component="label">
                            <FileUploadOutlinedIcon/>
                            Upload
                            <input hidden type="file" onChange={handleFileChange}/>
                          </Button>  
                          {/* Upload file button */}

                          {<p> {getFileName()}</p> } 
                          {/* show fileName */}

                          {/* {formErrors.url != "" && <p style={{ color: 'red', margin: '0 0 0 1em' }}>{formErrors.url}</p>} */}
                          {/* errors for file upload */}

                        </div>
                      </>
                      }
                    </>

                  )
                }
                
                <div className="icon-buttons" >
                    { linkIsFileInS3(localResource.url) 
                      ?<DownloadButton url={localResource.url}/>
                      :<RedirectButton url={localResource.url}/>
                    }
                    {!linkIsFileInS3(localResource.url) && <CopyButton copy={localResource.url}/>}
                </div>

            </div>

            <div>
              {
                canEdit?
                  <ResourceHeaderDropdown value={localResource.resourceHeaderId} onChangeHandler={(e)=>setLocalResource({...localResource, resourceHeaderId: e})} />
                  : <p> <span style={{fontWeight: "600"}}>Sub-Page Header:</span> {resourcesHeaders.find( e => e.id== localResource.resourceHeaderId )?.name}</p>
              }
            </div>
        </div>
    );
}

export default ResourceCard;